import(/* webpackMode: "eager" */ "/tmp/8de4fb25baf1ebc/src/app/page.tsx");
